import React, { FC, useContext, useEffect, useRef, useState } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
  Box,
  TextField,
  Card,
  CardContent,
  Grid,
  Typography,
  CircularProgress,
  Button,
  Dialog,
  DialogTitle,
  IconButton,
  DialogActions,
} from '@material-ui/core';

import List from './components/list';
import ListDetail from './components/detailList';

// types
import {InventoryItem} from '../../orderPick/interfaces';
import {Props} from './interface';
import Modal from '../../../components/Modal';
import Icon from '@mdi/react';
import {mdiClose, mdiCounter, mdiFileDocument, mdiFileReplace} from '@mdi/js';
import theme from '../../../theme';
import handleNotfication from '../../../utils/handleNotification';
import inventoryItemsRepository from 'client-sdk/src/Repository/inventory-items-repository';
import handleError from '../../../utils/handleError';
import Can from '../../../components/Can';
import AuthContext from '../../../authContext';

//styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    countSection: {
      display: 'flex',
      alignItems: 'center',
      color: '#8a8a8a',
    },
    itemTitle: {
      fontSize: '0.9rem',
      fontWeight: 500,
      color: '#383836',
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
      margin: '10px auto',
      // direction: 'rtl',
    },
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    textArea: {
      width: '100%',
    },
    box: {
      display: 'flex',
      backgroundColor: '#fff',
      padding: theme.spacing(2, 3),
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    boxIcon: {
      marginRight: '30px',
    },
    allCenter: {
      position: 'relative',
      marginRight: '30px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#B297A7',
      },
    },
    activeCenter: {
      position: 'relative',
      marginRight: '30px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#039590',
      },
    },
    deActiveCenter: {
      position: 'relative',
      marginRight: '30px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#ddd',
      },
    },

    title: {
      display: 'flex',
      alignItems: 'center',
      color: '#8A8A8A',
      fontSize: '16px',
      fontWeight: 500,
      marginRight: '8px',
    },
    text: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '21px',
      fontWeight: 500,
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },

    iconButton: {
      padding: 10,
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      top: '47px',
      right: '0',
      marginTop: '12px',
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },

    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },

    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    card: {
      minWidth: '195px',
      display: 'flex',
      background: '#fff',
      padding: '8px 4px',
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    cardItem: {
      margin: '0 4px',
      flex: 1,
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
  })
);

const RelocateByItem: FC<Props> = ({}: Props): React.ReactElement => {
  const authContext = useContext(AuthContext)
  const classes = useStyles();
  const inputRef = useRef<HTMLInputElement>(null);
  const targetRef = useRef<HTMLInputElement>(null);
  const [targetInput, setTargetInput] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [unitInput, setUnitInput] = useState('');
  const [list, setList] = useState<InventoryItem[]>([]);
  const [openModal, setOpenModal] = useState(false as boolean);
  const [targetDialog, setTargetDialog] = useState(false as boolean);

  const [inventoryItem, setInventoryItem] = useState([]);
  const [inventoryItems, setInventoryItems] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [inventoryItemLoading, setInventoryItemLoading] =
    useState<boolean>(false);
  const [relocateLoading, setRelocateLoading] = useState(false as boolean);

  const [checkRelocateDialog, setCheckRelocateDialog] = useState(
    false as boolean
  );
  const relocateByItem = async (action: any, submitRelocateCallback: any) => {
    const payload = {...action};
    try {
      const callback = await inventoryItemsRepository.relocateByaItem(
        {payload},
        submitRelocateCallback
      );
      handleNotfication('جابه‌جایی با موفیت انجام شد', 'success');
      if (callback) {
        callback();
      }
    } catch (error) {
      handleError(error.response);
    }
  };
  const getParcelInventoryItems = async (action: any) => {
    const payload = {...action};
    try {
      setInventoryItemLoading(true);
      const {response, callback} =
        await inventoryItemsRepository.getParcelInventoryItems({payload});
      setInventoryItem(response.data.content);
      if (callback) {
        callback();
      }
    } catch (error) {
      handleError(error.response);
    } finally {
      setInventoryItemLoading(false);
    }
  };
  const getInventoryItemsWithSerial = async (action: any, cleanInput: any) => {
    const payload = {...action};
    try {
      setLoading(true);
      const {response, callback} =
        await inventoryItemsRepository.getInventoryItemsWithSerial(
          {payload},
          cleanInput
        );
      if (callback) {
        callback();
      }
      setInventoryItems(response.data.content);
      if (response.data.content.length === 0)
        handleNotfication('هیچ آیتمی پیدا نشد.', 'warn');
    } catch (error) {
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleChangeInput = ({target}: React.ChangeEvent<{value: string}>) => {
    setInputValue(target.value);
  };

  useEffect(() => {
    if (inputValue.length === 10) {
      getInventoryItemsWithSerial(
        {'serialNumber.equals': inputValue},
        cleanInput()
      );
    }
  }, [inputValue]);

  const cleanInput = () => {
    setInputValue('');
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const checkDuplicateItem: () => any[] = () => {
    const items: any[] = []
    for (let i = 0; i < inventoryItems.length; i++) {
      const element = inventoryItems[i];
      const checkItems = list.find(el => el.id === element.id);
      if (element.status !== 'LOCATED') {
        handleNotfication(`جاگذاری نشده است ${element.serialNumber} سریال`, 'warn');
      }else if(!checkItems) {
        items.push(element)
      }     
    }
    return items;
  }

  useEffect(() => {
    if (inventoryItems.length > 0) {
      setList([...checkDuplicateItem(), ...list])
    }
  }, [inventoryItems]);

  const handleOpenModal = (skuId: number) => {
    setOpenModal(true);
    getParcelInventoryItems({'skuId.equals': skuId});
  };

  const handleRemoveItem = (id: number) => {
    setList(list.filter(el => el.id !== id));
  };

  const handleOpenTargetDialog = () => {
    setTargetDialog(true);
    if (targetRef.current) {
      targetRef.current.focus();
    }
  };

  const handleCloseTargetDialog = () => {
    setTargetDialog(false);
    setTargetInput('');
  };

  const handleChangeTarget = ({target}: React.ChangeEvent<{value: string}>) => {
    setTargetInput(target.value);
  };

  const handleOpenCheckDialog = () => {
    setCheckRelocateDialog(true);
  };

  const handleCloseCheckDialog = () => {
    setCheckRelocateDialog(false);
    setTargetInput('');
  };

  const handleSubmitRelocate = () => {
    const payload = {
      barcode: targetInput,
      ids: list.map(item => item.id),
    };
    relocateByItem(payload, submitRelocateCallback());
  };

  const submitRelocateCallback = () => {
    setList([]);
    handleCloseCheckDialog();
    handleCloseTargetDialog();
  };
  const inputKeyHandler = (e: any) => {
    if (e.key == 'Enter') {
      setCheckRelocateDialog(true);
    }
  };
  const secondKeyPress = (e: any) => {
    if (e.key == 'Enter') {
      handleSubmitRelocate();
      setCheckRelocateDialog(false);
    }
  };

  const searchWithUnit = (e:any) => {
    e.preventDefault()
    if(unitInput.length > 0) {
      getInventoryItemsWithSerial(
        {'unitBarcode.equals': unitInput, size: 1000, "status.equals": "LOCATED"},
        setUnitInput("")
      );
    }
  }
  return (
    <div className={classes.root}>
      <Grid container justify="space-between" item xs={12} alignItems="center">
        <Grid item>
          <Typography variant="h6" component="h2">
            جابه‌جایی آیتم انبار
          </Typography>
        </Grid>
      </Grid>
      <Box mb={4} />
      <Grid container justify="center" item xs={12} alignItems="center">
        <Grid xs={12} md={8} item>
          <Card>
            <CardContent>
              <Grid
                container
                alignItems={'center'}
                justify={'space-around'}
                spacing={4}
              >
                <Grid item xs={12} sm={6}>
                  <div className={classes.item}>
                    <TextField
                      onChange={handleChangeInput}
                      inputRef={inputRef}
                      inputProps={{maxLength: 10}}
                      id="barcode"
                      value={inputValue}
                      label="سریال بارکد"
                      variant="outlined"
                    />
                  </div>
                </Grid>
                <Grid item style={{textAlign: 'center'}} xs={12} sm={6}>
                  <Typography className={classes.itemTitle} component="span">
                    سریال آیتم‌ها را اسکن کنید
                  </Typography>
                </Grid>
              </Grid>
              <Can
                role={authContext.user.role}
                perform="relocate:unit"
                yes={() => (
                <form onSubmit={searchWithUnit}>
                  <Grid
                    container
                    alignItems={'center'}
                    justify={'space-around'}
                    spacing={4}
                  >
                    <Grid item xs={12} sm={6}>
                      <div className={classes.item}>
                        <TextField
                          onChange={e => setUnitInput(e.target.value)}
                          inputProps={{maxLength: 10}}
                          id="barcode"
                          value={unitInput}
                          label="بارکد یونیت"
                          variant="outlined"
                        />
                      </div>
                    </Grid>
                    <Grid item style={{textAlign: 'center'}} xs={12} sm={6}>
                      <Typography className={classes.itemTitle} component="span">
                        بارکد یونیت را اسکن کنید
                      </Typography>
                    </Grid>
                  </Grid>
                </form>
                )}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Box mb={4} />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <div className={classes.countSection}>
            <Icon className="icon" path={mdiCounter} size={1} />
            <h5>مجموع آیتم‌های اسکن شده :</h5>
            <h5 style={{marginRight: '5px'}}>{list?.length}</h5>
          </div>
        </Grid>
        <Grid item xs={12}>
          {loading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            <List
              handleRemoveItem={handleRemoveItem}
              data={list}
              handleOpenDetail={handleOpenModal}
            />
          )}
        </Grid>
        <Box mb={4} />
        {list.length > 0 && (
          <Grid container item alignItems={'center'} justify={'space-between'}>
            <Grid item>
              <div className={classes.countSection}>
                <h5></h5>
                <h5></h5>
              </div>
            </Grid>
            <Grid item>
              <Button
                aria-label="register-parcel"
                style={{display: 'flex'}}
                onClick={handleOpenTargetDialog}
                color="secondary"
                variant="contained"
                disabled={list.length === 0}
              >
                <Icon path={mdiFileReplace} size={1} />
                <span>جا‌به‌جایی</span>
              </Button>
            </Grid>
          </Grid>
        )}
      </Grid>

      <Modal
        maxWidth={'lg'}
        onClose={() => setOpenModal(false)}
        open={openModal}
        title={
          <>
            <div className={classes.addIcon}>
              <Icon
                path={mdiFileDocument}
                size={4}
                color={theme.palette.green.main}
              />
            </div>
            <Typography
              style={{
                textAlign: 'center',
                marginTop: '10px',
                marginBottom: '20px',
              }}
              variant={'h6'}
              component={'h6'}
            >
              موجودی کالا در سایر یونیت ها
            </Typography>
          </>
        }
        content={
          inventoryItemLoading && inventoryItem.length ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            <ListDetail data={inventoryItem} />
          )
        }
      />

      <Dialog
        fullWidth
        open={targetDialog}
        onClose={handleCloseTargetDialog}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            <IconButton aria-label="close" onClick={handleCloseTargetDialog}>
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>
          <div className={classes.cancelTitle}>
            <Grid container justify={'center'} xs={12}>
              <Grid item xs={8}>
                <Typography
                  style={{
                    textAlign: 'center',
                    marginTop: '10px',
                    marginBottom: '30px',
                  }}
                  variant={'h6'}
                  component={'h6'}
                >
                  بارکد یونیت مورد نظر را اسکن کنید
                </Typography>
                <div
                  style={{justifyContent: 'center'}}
                  className={classes.item}
                >
                  <TextField
                    onChange={handleChangeTarget}
                    onKeyUp={inputKeyHandler}
                    inputRef={targetRef}
                    id="barcode"
                    value={targetInput}
                    label="سریال بارکد"
                    variant="outlined"
                    autoFocus
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                onClick={handleCloseTargetDialog}
                variant="contained"
                size="large"
              >
                {'انصراف'}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                onClick={handleOpenCheckDialog}
                disabled={targetInput.length === 0}
                fullWidth
                variant="contained"
                size="large"
                color="secondary"
              >
                بله
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth
        open={checkRelocateDialog}
        onClose={handleCloseCheckDialog}
        aria-labelledby="responsive-dialog-title"
        onKeyUp={secondKeyPress}
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
              top: '5px',
            }}
          >
            <IconButton aria-label="close" onClick={handleCloseCheckDialog}>
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>
          <div className={classes.cancelTitle}>
            <Grid item direction={'column'} xs={12}>
              <Typography
                style={{
                  textAlign: 'center',
                  marginTop: '30px',
                  marginBottom: '30px',
                }}
                variant={'h6'}
                component={'h6'}
              >
                {`ایا از تغییر مکان آیتم های مورد نظر به یونیت ${targetInput} مطمئن هستید؟`}
              </Typography>
            </Grid>
            <p style={{textAlign: 'right'}}>سریال کالاها:</p>
            {list.map((item, i) => (
              <p style={{textAlign: 'right'}} key={i}>
                {item.serialNumber}
              </p>
            ))}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                onClick={handleCloseCheckDialog}
                variant="contained"
                size="large"
              >
                {'انصراف'}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                onClick={handleSubmitRelocate}
                disabled={relocateLoading}
                fullWidth
                variant="contained"
                size="large"
                color="secondary"
              >
                بله
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
};

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
export default RelocateByItem;
